// @flow
import React from 'react'
import I18n from 'i18n-react'
import { humanizer } from 'devx-js-utilities'

// types

type SupplementaryInsuranceRowProps = {
  id: string,
  label: string,
  priceTranslationKey: string,
  priceText: string,
  selected: boolean,
  value: Object | string,
  onSelect: (Object | string) => void,
}

const SupplementaryInsuranceRow = (props: SupplementaryInsuranceRowProps) => {
  const handleOnClick = () => {
    props.onSelect(props.value)
  }

  return (
    <div className='row w-100' key={`${props.id}-row`}>
      <div className='col-4' key={`${props.id}-col1`}>
        {props.label}
      </div>
      <div className='col-3' key={`${props.id}-col2`}>
        {I18n.translate(props.priceTranslationKey, {
          price: `${humanizer.csNumber(props.priceText)} ${I18n.translate('general.currency')}`
        })}
      </div>
      <div className='col-3' key={`${props.id}-col3`}>
        {props.selected
          ? <button
            className='btn btn-secondary disabled btn-block px-0'
            type='button'
          >{I18n.translate('components.supplementaryInsurance.selected')}</button>
          : <button
            className='btn btn-secondary btn-block px-0'
            onClick={handleOnClick}
            type='button'
            value={props.value}
          >{I18n.translate('components.supplementaryInsurance.select')}</button>
        }
      </div>
      <div className='col-2' key={`${props.id}-col4`}/>
    </div>
  )
}

export default SupplementaryInsuranceRow
